var React = require('react');

function IconCross (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"currentColor","x":"24","y":"0","width":"2","height":"24","transform":"translate(2 -14) rotate(45)","key":0}),React.createElement("rect",{"fill":"currentCOlor","x":"24","y":"0","width":"2","height":"24","transform":"translate(-14 22) rotate(-45)","key":1})]);
}

IconCross.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = IconCross;

IconCross.default = IconCross;
